import { createContext } from "react";

const SessionContext = createContext({
    isExpired: false,
    setIsExpired: (expired: boolean) => {}
});

export default SessionContext;